// 质量监控平台详情
<template>
  <div style="background-color:white;" ref="scrollContainer">
	<header2/>
    <el-row type="flex" justify="center">
      <el-col :span="16" style="padding: 50px 17px 10px 17px;">
        <el-tabs type="border-card" tab-position="left" v-model="labelValue">
          <el-tab-pane name="monitorDetail">
            <span slot="label"><i class="el-icon-s-home"></i> 质量监控平台</span>
            
            <el-row type="flex" justify="left" style="margin-top: 30px;"><span class="line_title">质量监控平台</span><span class="line_title2"></span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>智能质检系统范围囊括人工客服服务质量、服务态度两大质检维度，深度挖掘客服对话数据，采用智能化<span style="font-weight: bold;">自动质检+人工审核</span>的组合方式，自动生成质检考核报表。</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>√ 全覆盖：智能质检系统覆盖在线人工客服与用户的每一句对话，完全覆盖，无遗漏。</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>√ 服务质量质检：对人工客服的响应时间、单问题会话轮数等进行质检考核。</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>√ 客服素质质检：对人工客服的服务态度、服务禁忌语、服务用语是否规范进行智能质检考核，自动发现问题对话。</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>√ 自检方式：系统可通过设置设定各维度智能质检的质检方式，分为自动质检和人工审核质检。</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>√ 自动质检：基于人工智能技术，对人工客服与用户对话进行智能分析，自动发现每一次对话的问题，自动进行量化评分评价。</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>√ 人工审核：系统对人工客服和用户的每一次对话进行智能分析，发现问题对话，并将问题对话智能筛选、分类，提交客服质检审核人员进行人工二次审核。</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><el-image :src="monitor01"></el-image></el-row>
			
			<el-row type="flex" justify="left" class="line_content"><span style="font-weight: bold;">过程监控</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>√ 现场观摩旁听指导：通过质检人员巡视现场，旁听外呼人员外呼情况，发现问题，并纠正、跟踪改进问题的方式来实现质量监控，提高坐席员的外呼质量。</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>√ 实时在线监听指导：外呼人员在拜访过程中，质检员通过系统现场监听外呼情况，及时发现外呼人员存在的问题，并纠正、跟踪改进问题的，提高坐席员的外呼质量。此方式具有及时性，能在最短时间内发现问题，并纠正问题，给用户良好感知。</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>√ 录音抽查监听指导：质检员根据发现的问题，通过事后抽查录音的方式对存在的问题进行再次确认或跟踪问题是否改进，此方式可保证发现问题的准确性和跟踪改进问题的彻底性。</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>√ 投诉反馈指导：申诉处理人员在处理申诉过程中发现外呼人员的口径存在投诉隐患，或发现某个外呼人员的申诉量较大时，及时反馈质检员，质检员根据反馈信息进行实时在线监听和录音抽查监听来确认问题，并辅导改进问题。</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>√ 质量监控频率：每日实施质量监控，每天均应保证每位外呼人员都有3个以上被监听记录（辅导性质检的方式）。</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><el-image :src="monitor02"></el-image></el-row>
			
			<el-row type="flex" justify="left" class="line_content"><span style="font-weight: bold;">指标监控</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>√ 外呼量：根据单天上班时间规定外呼量，人时量在30-50之间，需要根据每批次数据的拨测接通率进行合理定制。</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>√ 接通率：根据甲方拨测值进行定目标，此指标直接反应出数据质量，将直接影响到我们的整体效率情况。</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>√ 成功率：根据甲方的拨测值为基础目标，进行数据二遍拨测，达到甲方拨测值将做我们基础指标，并根据现场外呼情况挖掘原因，再进一步调整方法。</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>√ 客户满意度：该项指标将直接反映出服务态度是否能够得到客户的认可，针对满意度低于99%的人工座席进行单独分析，并听取录音，找到问题以便于更好的提升。</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>√ 有理投诉率：针对客户任何一个投诉都要进行重点的录音分析，从中找出被投诉的问题点，进行全员录音分享，以此警戒，控制有理由投诉的产生。</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><el-image :src="monitor03"></el-image></el-row>
			
			<el-row type="flex" justify="left" class="line_content"><span style="font-weight: bold;">质检数据报表</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>√ 客服组：支持快速创建、模版创建和批量导入多种知识库创建方式。</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>√ 分项目：根据不同的质检数据项目生成报表。</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>√ 量化数据：量化报表，支持横向对比、纵向对比。</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>√ 多维度导出报表：时间维度、客服维度、数据维度。</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>√ 自定义质检周期:根据需要自定义质检周期。</span></el-row>
			<el-row type="flex" justify="left" class="line_content"><span>√ 按周质检/按月质检：一键选择最近一周/最近一月的质检数据。</span></el-row>
			
			
			
            <!--<el-row type="flex" justify="left" class="line_content"><span>泰盈科技集团股份有限公司是中国呼叫中心及电商后台客服行业领跑者，与国内外互联网、电子商务、通信、金融、物流、制造业等行业中的近30家领先企业建立了战略合作关系。全面为合作企业提供客户服务整体解决方案、呼叫中心运营、电商后台运营、呼叫中心及电商后台人才服务、企业专业客服等核心服务。</span></el-row>

            <el-row type="flex" justify="left" style="margin-top: 20px;"><span class="line_title">企业战略：</span></el-row>
            <el-row type="flex" justify="left" class="line_content"><span>公司将秉承“创外包之泰、享服务之盈”的核心价值观，抓住国家对外开放和产业升级的历史机遇，加速全国互联网与电子商务后台基地、金融业后台处理基地、通信业后台处理基地、制造业后台处理基地的规模扩张，依托“泰盈云”战略，进一步提升核心竞争力，争做全球BPO行业领军企业。</span></el-row>

            <el-row type="flex" justify="left" style="margin-top: 20px;"><span class="line_title">公司荣誉：</span></el-row>
            <el-row type="flex" justify="left" class="line_content"><span>泰盈科技集团股份有限公司自成立以来，凭借可信赖的交付能力，在得到合作客户广泛赞誉的同时，也成为国家多部委和相关机构公认的BPO行业领军企业。</span></el-row>

            <el-row type="flex" justify="left" style="margin-top: 10px;"><span class="line_title" style="color: black;">获取荣誉</span></el-row>
            <el-row class="line_content">
              <div>1、中国信息技术服务产业联盟常务副理事长单位</div>
              <div>2、国家工信部中国呼叫中心与电商后台专委会理事长单位</div>
              <div>3、商务部“重点联络服务外包企业”</div>
              <div>4、国标委“呼叫中心服务标准化试点单位”</div>
              <div>5、中华全国中工会“模范职工小家”</div>
              <div>6、共青团中央“青年就业创业见习基地”</div>
              <div>7、中国呼叫中心与电子商务研究院“中国最佳客户中心”</div>
              <div>8、工信部软件与集成电路促进中心“中国最佳外包客户联络中心”</div>
            </el-row>

            <el-row type="flex" justify="left" style="margin-top: 10px;"><span class="line_title" style="color: black;">通过的认证</span></el-row>
            <el-row class="line_content">
              <div>1、高新技术企业</div>
              <div>2、双软企业</div>
              <div>3、ISO9001国际质量体系</div>
              <div>4、ISO27001国际信息安全体系</div>
            </el-row>-->

          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
	<footer2/>
  </div>
</template>

<script>
  import header2 from '@/components/base/header2.vue'
  import footer2 from '@/components/base/footer2.vue'
  export default {
    data() {
      return {
        labelValue:this.$route.name,
		monitor01:require("../../assets/ecology/monitor01.png"),
		monitor02:require("../../assets/ecology/monitor02.png"),
		monitor03:require("../../assets/ecology/monitor03.png"),
      }
    },
    mounted() {this.scrollToTop();},
    created() {},
	components: {
	  header2,
	  footer2
	},
    computed: {},
    methods: {
		scrollToTop() {
		      this.$nextTick(() => {
		        this.$refs.scrollContainer.scrollTop = 0;
		      });
		    }
	}
  }
</script>

<style scoped>
.line_title{
  color: #096FED;
  font-size: 16px;
  font-weight: bolder;
  display: inline-block;
  padding-left: 28px;
}
.line_title2{
  color: #b6b6b6;
  font-size: 14px;
  display: inline-block;
  padding: 4px 0px 0px 8px;
}
.line_content{
  font-size: 14px;
  line-height: 25px;
  margin-top: 15px;
  text-indent: 2em;
  text-align: left;
}
.adv_title{
  font-weight:bold;
  font-size:24px;
  text-align:left;
  padding-left:10px;
  padding-top:10px;
  margin-bottom: 20px;
}
.adv_content{
  font-size:14px;
  text-align:left;
  padding-left:10px;
  color:#8c9095;
  padding-top:10px;
}
</style>

<style>
.el-main{
  padding:0px;
}
</style>